import React, { PureComponent } from 'react';
import { Marker, Popup } from 'react-leaflet';
import classnames from 'classnames';
import Button from 'common/components/core/button';

import { listCardFactory } from 'common/components/core/card/ListCard';
import theme from './ZoneMapSearchMarker.scss';
import NumberUtils from 'common/utils/NumberUtils';

const DeleteSearchPinIcon = ({ onDelete, label }) => (
    <Button
        onClick={onDelete}
        className={theme.deleteBtn}
        icon="delete-bin"
        label={label}
        theme={theme}
        ripple={false}
        semibold
    />
);

const SearchPopupSubtitle = ({ description, latLng }) => (
    <div className={theme.searchSubtitleWrap}>
        <span className={theme.description}>{description}</span>
        <span className={theme.latLng}>
            {latLng
                .map(coordinate => NumberUtils.round(coordinate, 4))
                .join(', ')}{' '}
        </span>
    </div>
);

const PlacesSearchCard = listCardFactory({
    Subtitle: SearchPopupSubtitle,
    ExtraContent: DeleteSearchPinIcon
});

class ZoneMapSearchMarker extends PureComponent {
    state = { targetLayer: null };
    layerRef = ref => {
        const { panTo } = this.props;
        const targetLayer = ref && ref.leafletElement;
        targetLayer && targetLayer.openPopup();
        targetLayer && panTo(targetLayer);
    };

    onDelete = () => {
        const {
            onDelete,
            geometry: { id }
        } = this.props;
        onDelete({ zoneId: id });
    };

    render() {
        const { geometry, className } = this.props;
        const [latLng] = geometry.geometry.polygon.getVertices();
        return (
            <Marker position={latLng} ref={this.layerRef}>
                <Popup className={theme.searchPopup}>
                    <PlacesSearchCard
                        theme={theme}
                        title={geometry.name}
                        description={geometry.description}
                        latLng={latLng}
                        label={'Delete'}
                        onDelete={this.onDelete}
                        className={classnames(theme.searchCard, className)}
                    />
                </Popup>
            </Marker>
        );
    }
}

export default ZoneMapSearchMarker;
